import { NullQ } from "@pdfking/structs"

import type { GrowLeaf } from "#internal"

/**
 * What the name block calls a piece. On a box its face, `A` to `F`, and
 * nothing else. Elsewhere a named one — a cover's A and B, a folder's panel
 * C — its name and its number in the job, one named empty — a book's blank —
 * nothing; one with a place in the reading order its `number` — "×" while it
 * has none —; anything else — a spine, a flap — nothing.
 */
export const GrowLabel = (
  leaf: GrowLeaf | undefined,
  number: number | undefined,
  job_number: number | undefined,
  is_box: boolean
): string => {
  if (is_box) return leaf?.meta.label ?? ""
  if (leaf && !NullQ(leaf.meta.label))
    return leaf.meta.label && `${leaf.meta.label}${job_number ?? ""}`
  if (!leaf || !NullQ(leaf.meta.page_front) || !NullQ(leaf.meta.page_rear))
    return number ? String(number) : "×"
  return ""
}
